import type { ISearchFilterInput } from '../../../../types/data_table';

import { MagnifyingGlass } from '../../../../assets/Icons';

import { Input } from '../../../Input';

/**
 * An inline search box.
 *
 * Unlike the other field filters it has no Apply step — the bar debounces the
 * value on its behalf, so this stays a plain controlled input.
 */
export const SearchFilterInput = ({
  filter,
  value,
  index,
  disabled,
  onChange,
}: ISearchFilterInput) => (
  <Input
    id={filter.id}
    // The bar's stylesheet widens search inputs by matching on this name.
    name={`${filter.type}-filter-${index}`}
    placeholder={filter.placeholder}
    leadingIcon={MagnifyingGlass}
    value={value}
    disabled={disabled}
    onChange={(event) => onChange(event.target.value)}
  />
);
